import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

import styles from "./PayPieChart.module.scss";
import Legend from "components/PayEquity/Legend";

const PayPieChart = ({ title, description, data, labels, isLoading }: any) => {
  const [legendData, setLegendData] = useState<any>([]);
  const [pieChartOptions, setPieChartOptions] = useState<ApexOptions>({
    chart: {
      type: "pie",
      height: "100%",
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              formatter: () => "100%"
            }
          }
        }
      }
    },
    colors: ["#FFC759", "#00C29B"],
    dataLabels: {
      enabled: false
    },
    legend: {
      show: false,
      position: "bottom",
      fontSize: "16px",
      fontWeight: 400,
      markers: {
        size: 16, // to be checked
        // width: 16,
        // height: 16,
        // radius: 5
      },
      itemMargin: {
        horizontal: 10
      }
    },
    labels: ["Female", "Male"],
    series: []
  });

  useEffect(() => {
    if (data && data.length) {
      const female = data[0] || 0;
      const male = data[1] || 0;
      setPieChartOptions({
        ...pieChartOptions,
        series: [female, male]
      });

      setLegendData([
        {
          name: (
            <>
              Female <strong>{female}%</strong>
            </>
          ),
          color: "#FFC759"
        },
        {
          name: (
            <>
              Male <strong>{male}%</strong>
            </>
          ),
          color: "#00C29B"
        }
      ]);
    }
  }, [data]);

  return (
    <>
      <div className={styles.chartWrapper}>
        <div className={styles.chartTitle}>{title}</div>
        <Chart
          options={pieChartOptions}
          series={pieChartOptions.series}
          type="donut"
          height={250}
        />
        <Legend data={legendData || []} title="" className="" />
        <div className={styles.chartDescription}>{description}</div>
      </div>
    </>
  );
};

export default PayPieChart;
